// extracted by mini-css-extract-plugin
module.exports = {"btnBlue":"editWorkflow_btnBlue_3-W8k","btnBlueOutline":"editWorkflow_btnBlueOutline_3Ll_R","invalidCoding":"editWorkflow_invalidCoding_qeSyd"};